import { CommonModel } from "services/Main/common_services";
import { DataResponse } from "services/response";
import { BASE_API_URL } from "utils/constants";
import { downloadFilePostNew, get, post } from '../../utils/api';


// ================================ MẪU KHẢO SÁT =================================================================
export interface SurveyAPIModel {
  stt: number;
  id: string;
  code: number;
  name: string;
  aliasName: string;
  validDate: number;
  createTime: string;
  createBy: string;
  actived: boolean;
  customerName?: string;
}

export interface SurveyDetailsModel extends SurveyAPIModel {
  imageUrl?: string;
  description: string;
  sections: Section[]
}

export interface Section {
  sectionId: string;
  sectionName?: string;
  description?: string,
  orderIndex: number;
  questions: Question[];
  aliasName: string;
}

export interface Question {
  questionId: string;
  questionName: string
  type: string
  isRequired?: boolean
  isScore?: boolean
  answers: Answer[]
}

export type Answer = {
  answerId: string;
  answer?: string
  score?: number
  sectionOrderIndex?: number
  sectionId?: string
}

// ==== TABLE SURVEY REPORT HEADER =================================================================
export interface TableReportHeader {
  stt: number;
  id: string;
  display: string;
  key: string;
  childrens: TableReportChildren[]
}
export interface TableReportChildren {
  keyChildren: string;
  dataType: string
}

export interface SurveyReportModel {
  key: string;
  value: string[] | number[] | Answer[]
}






// ============ Khai báo phương thức =====================

export interface ISurveyServices {
  // Danh sách Survey
  getListSurvey(data: object): Promise<DataResponse<Array<SurveyAPIModel>>>
  // Tạo mẫu khảo sát
  createSurvey(data: object): Promise<DataResponse<null>>
  // Edit khảo sát
  editSurvey(data: object): Promise<DataResponse<null>>
  // Chi tiết mẫu khảo sát
  getSurveyById(params: { id?: string; taskId?: string }): Promise<DataResponse<SurveyDetailsModel | undefined>>

  //lưu câu trả lời form khảo sát
  saveDataAnswer(data: object): Promise<DataResponse<null>>
  // header table báo cáo
  getTabaleReportHeader(surveyId: string): Promise<DataResponse<TableReportHeader[]>>
  // lấy data báo cáo (có phân trang)
  getDataSurveyReport(data: object): Promise<DataResponse<SurveyReportModel[]>>

  // common survey
  getListCommonSurvey(keyWord?: string, createTimeFrom?: string, createTimeTo?: string): Promise<DataResponse<Array<CommonModel>>>
  // Xuât Excel báo cáo
  exportExcelSurvey(data: object): Promise<void>


  // xóa câu hỏi trong 1 khảo sát cụ thể
  deleteQuestionInSurvey(questionId: string): Promise<DataResponse<boolean>>
  // check xóa phần có chưa câu hỏi trong 1 khảo sát cụ thể
  deleteSessionInQuesSurvey(Id: string): Promise<DataResponse<boolean>>
}
// Hàm khởi tạo các phương thức của Báo cáo bảo hành và khiếu nại service
export function createSurveyServices(): ISurveyServices {
  return {
    // Danh sách Survey
    getListSurvey: async (data) => {
      return (await post(BASE_API_URL, `Survey/list`, data)).data;
    },
    // Tạo mẫu khảo sát
    createSurvey: async (data) => {
      return (await post(BASE_API_URL, `Survey/create`, data)).data;
    },
    // Edit khảo sát
    editSurvey: async (data) => {
      return (await post(BASE_API_URL, `Survey/edit`, data)).data;
    },
    // Chi tiết mẫu khảo sát
    getSurveyById: async (params) => {
      console.log('params', params);
      return (await get(BASE_API_URL, `Survey/get/` + params.id, { taskId: params.taskId && params.taskId !== 'null' ? params.taskId : undefined })).data
    },
    //lưu câu trả lời form khảo sát
    saveDataAnswer: async (data) => {
      return (await post(BASE_API_URL, `Survey/save-data-answer`, data)).data;
    },
    // header table báo cáo
    getTabaleReportHeader: async (surveyId) => {
      return (await get(BASE_API_URL, `Survey/question/` + surveyId)).data
    },
    // lấy data báo cáo (có phân trang)
    getDataSurveyReport: async (data) => {
      return (await post(BASE_API_URL, `Survey/report-survey`, data)).data;
    },
    // common survey
    getListCommonSurvey: async (keyWord, createTimeFrom, createTimeTo) => {
      return (await get(BASE_API_URL, `Common/list-sv`,
        {
          key: keyWord,
          CreateTimeFrom: createTimeFrom,
          CreateTimeTo: createTimeTo
        })).data
    },
    // Xuât Excel báo cáo
    exportExcelSurvey: async (data) => {
      await downloadFilePostNew(BASE_API_URL, 'Survey/export-excel-survey', data)
    },


    // xóa câu hỏi trong 1 khảo sát cụ thể
    deleteQuestionInSurvey: async (questionId) => {
      return (await get(BASE_API_URL, `Survey/check/` + questionId)).data
    },
    // check xóa phần có chưa câu hỏi trong 1 khảo sát cụ thể
    deleteSessionInQuesSurvey: async (Id) => {
      return (await get(BASE_API_URL, `Survey/check-section/` + Id)).data
    },
  };
}
